import React from 'react';
import { connect } from  'react-redux';
import { Redirect, Link } from 'react-router-dom';
import {API_URL} from '../../actions/_request';
import {api} from '../../actions/_request';


//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';
import ReactTable from "react-table";
import "react-table/react-table.css";
import swal from 'sweetalert2';

// styling
import './style.css';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';



import _ from "lodash";

import * as actions from '../../actions/ticket';

import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Fasearch from 'react-icons/lib/fa/search';
import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import IconCheck from 'react-icons/lib/md/check';
const {PropTypes} = React;

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
       
        var pagado='';
        var pv='';
        var proceso='';
        var cliente='';
        var ticket='';
        var tecnico='';
        var fecha='';

        var take= pageSize;
        var skip=pageSize * page;
        var total=1; 
        var patt = new RegExp("(si|s)", "i"); 
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "pagado":
              
              
               patt = new RegExp("(si|s)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PAGADO---> 1');
                pagado=1;

              }else{
                patt = new RegExp("(no|n)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PAGADO---> 0');
                pagado=0;

              }else{
                patt = new RegExp("("+filtered[i].value+")", "i");
              if('credito'.search(patt)==0){
                console.log('PAGADO---> 2');
                pagado=2;
              }

              }

              }
              break;
            case "pv":
             
               patt = new RegExp("(si|s)", "i");
              if(filtered[i].value.search(patt)==0){
                console.log('PV---> 1');
                pv=1;

              }else{
                patt = new RegExp("(no|n)", "i");
                if(filtered[i].value.search(patt)==0){
                  console.log('PV---> 0');
                  pv=0;
                }

              }
              break;            
            case "processName":
              patt = new RegExp("("+filtered[i].value+")", "i");
              if('inicio'.search(patt)==0){
                console.log('proceso---> 1');
                proceso=1;
              }else{
                  patt = new RegExp("("+filtered[i].value+")", "i");
                  if('proceso'.search(patt)==0){
                    console.log('proceso---> 2');
                    proceso=2;
                  }else{
                    patt = new RegExp("("+filtered[i].value+")", "i");
                    if('finalizado'.search(patt)==0){
                      console.log('proceso---> 3');
                      proceso=3;
                    }else{
                      patt = new RegExp("("+filtered[i].value+")", "i");
                      if('cancelado'.search(patt)==0){
                        console.log('proceso---> 4');
                        proceso=4;
                      }else{
                        patt = new RegExp("("+filtered[i].value+")", "i");
                        if('garantia'.search(patt)==0){
                          console.log('proceso---> 5');
                          proceso=5;
                        }
                      }

                  }
              }
            }

              break;
            case "created_at":
              fecha=filtered[i].value;
               console.log('fecha--->',filtered[i].value);
              break;
              case "cliente":
              cliente=filtered[i].value;
              console.log('cliente--->',filtered[i].value);
              break; 
              case "clave":
              ticket=filtered[i].value;
              console.log('clave--->',filtered[i].value);
              break; 
              case "asignado":
              tecnico=filtered[i].value;
              console.log('asignado--->',filtered[i].value);
              break;              
          }
        }
              
              api().get(`/tickets/busqueda?fecha=${fecha}&cliente=${cliente}&ticket=${ticket}&tecnico=${tecnico}&proceso=${proceso}&pv=${pv}&pagado=${pagado}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data.datos;
                  total= response.data.total; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
        
    });
};

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true,
             fecha:moment().format('Y-MM-DD'),
             fecha_2 : moment().add(1, 'days').format('Y-MM-DD'),
        };

      
        this.recargar = this.recargar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.validar_rfc = this.validar_rfc.bind(this)

    }
   validar_rfc(evt)
  {
    evt.preventDefault();
        // console.log('Factura------>',factura)
        

       let self = this;
       // self.props.correo(1,[]);
      swal.queue([{
        title: 'Estas seguro?',
        text: "De Timbrar el ticket",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/validar_rfc/IAD121214')
            .then(function(response)
            {    
                console.log('response-->',response)    
                if(response.status === 200)
                {   
                   if(response.data.estado==200){

                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  // self.props.timbrar(response.data.factura);

                  // console.log('liga pdf-->  '+API_URL+'/pdf_factura/'+response.data.factura+'/I') ;
                  // window.open(API_URL+'/pdf_factura/'+response.data.factura.id+'/I');
                  // self.props.correo(1,response.data.factura);

                   }else{
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                  
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }]);
    
  }
   handleInputChange(event) {

        if(event === null) return;

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;



        this.setState({
                [name]: value           
        });

       

    }

    confirmacion(evt,id,ticket){
      let self =this;
              swal({
        title: 'Estas seguro?',
        text: "se Reasignara el ticket: "+ticket,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
         cancelButtonText: 'Cancelar!'
      }).then((result) => {
        if (result.value) {
            
        

          let datos={
            id:id,
            usuario_id:this.props.auth.user.id
          };
          console.log('Reasignacion----->',datos);

          /*pagar credito es una funcion para actualizar  el ticket sin validaciones por eso se reutilizo 
           pero no le cambien el nombre por que ya la usaba en otros modulos*/
           this.props.pagar_credito(datos, (response) => {   
            self.recargar();
          swal("Bien hecho!", "El ticket fue Reasignado con éxito!", "success");       
      });    
        }
      })
    }

  recargar(){
      let self = this;
      console.log("recargar");

      // this.props.alerta({
      // mensaje:"Error al Capturar",
      // tipo:"success",
      // creacion:moment().format('Y-MM-DD H:m:s'),
      // });


      let url=`/tickets_ventas_clientes2/${this.props.auth.user.id}/${this.state.fecha}/${this.state.fecha_2}`;
        api().get(url)
        .then(function(response)
        {
            self.setState({
                data : response.data,
                loading:false,
            });
           
        })
    
  }



    componentDidMount(){
    this.recargar();

    }

      


    render() {
const { data, pages, loading } = this.state;
        return(
            <div className="view">

               

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row mb-3">
                                
                                
                                
                                
                                <div className="col-sm-4 col-md-2 col-12">
                                    <div className="form-group">
                                        <label className>Fecha Inicio</label>
                                        <input
                                            type="date" 
                                            className="form-control"
                                            name="fecha"
                                            value={this.state.fecha || ''}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-sm-4 col-md-2 col-12">
                                    <div className="form-group">
                                        <label className>Fecha Final</label>
                                        <input
                                            type="date" 
                                            className="form-control"
                                            name="fecha_2"
                                            value={this.state.fecha_2 || ''}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                                
                               
                                
                                 
                                <div className="col-sm-4 col-md-2 col-12 text-right">
                                    <label><br/></label><br/>
                                    <Button color='success' onClick={this.recargar}> <Fasearch/> </Button>
                               
                                </div>
                            </div>

                            <ReactTable
                             getTrProps={(state, rowInfo, column) => {
                                 
                                  if(rowInfo === undefined){
                                         
                                          return{

                                          }
                                        }else{
                                           return{
                                           onDoubleClick: (evt)=>this.confirmacion(evt, rowInfo.original.id, rowInfo.original.clave)
                                        } 
                                  
                                    }
                              }}
                              
                              
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'created_at',maxWidth:100},
                                {Header: 'Tecnico', accessor: 'asignado',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:80,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                  onClick={(evt)=>this.confirmacion(evt, row.original.id, row.original.clave)}>
                                                    <IconCheck />
                                                </Button>
                                            </div>
                                        )
                                    }
                                }
                              ]}
                            
                              data      = {this.state.data}
                              defaultFilterMethod={filterCaseInsensitive}
                              loading={loading} // Display the loading overlay when we need it
                             
                              filterable
                             
                              defaultPageSize={10} 
                             
                              
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>                                   
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Iva</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>
                                                   <td>{item.subtotal_formato}</td>
                                                   <td>{item.iva_formato}</td>
                                                   <td>{item.total_formato}</td>   
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
        auth:state.auth,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(TicketTable)




// WEBPACK FOOTER //
// ./src/views/dashboard/reporte_ventas_clientes.js